import React from "react";
import PropTypes from "prop-types";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import PresentationModes, { PRESENTATION_MODE } from "~/constants/presentation-modes";
import { displayModeType } from "~/constants/prop-types";
import { styled } from "@mui/material/styles";

const modes = Object.values(PresentationModes);

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  "@media (max-width: 768px)": {
    width: "40px"
  }
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  color: "white",
  "&:focus": {
    backgroundColor: "rgba(0, 0, 0, 0)"
  },
  "& .MuiSelect-select:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-5px"
  }
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function ModeSwitcher({ classes, mode, onChange, showPresentationMode, showDisplayModeSwitch }) {
  const modesToRender = showPresentationMode ? modes : modes.filter(mode => mode.value !== PRESENTATION_MODE);

  return (
    showDisplayModeSwitch && (
      <StyledFormControl variant="standard">
        <StyledSelect variant="standard" disableUnderline value={mode} onChange={onChange}>
          {modesToRender.map(({ label, value }) => (
            <StyledMenuItem key={value} value={value}>
              {label}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    )
  );
}

ModeSwitcher.propTypes = {
  onChange: PropTypes.func.isRequired,
  mode: displayModeType.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  showPresentationMode: PropTypes.bool.isRequired,
  showDisplayModeSwitch: PropTypes.bool.isRequired
};

export default ModeSwitcher;
